import { render, staticRenderFns } from "./GradientIcon.vue?vue&type=template&id=a5f1c382&scoped=true&"
import script from "./GradientIcon.vue?vue&type=script&lang=js&"
export * from "./GradientIcon.vue?vue&type=script&lang=js&"
import style0 from "./GradientIcon.vue?vue&type=style&index=0&id=a5f1c382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f1c382",
  null
  
)

export default component.exports